export const BidHistory = ({ bids }) => (
  <div className="mt-20 max-w-3xl">
    <p className="label-eyebrow text-[#1E3A8A]">— Bid History</p>
    <h2 className="font-serif-display text-3xl font-medium mt-2 text-[#111]">
      {bids.length} bid{bids.length === 1 ? "" : "s"} on this work
    </h2>
    {bids.length === 0 ? (
      <p className="mt-6 text-[#555]">No bids yet. Be the first.</p>
    ) : (
      <div className="mt-8 border border-[#E5E0D8] bg-white" data-testid="bid-history">
        {bids.map((b, i) => (
          <div
            key={b.id}
            className={`flex items-center justify-between p-4 border-b border-[#E5E0D8] last:border-b-0 ${
              i === 0 ? "bg-[#F4EFE6]/40" : ""
            }`}
          >
            <div>
              <p className="text-sm text-[#111]">{b.bidder_name}</p>
              <p className="label-eyebrow text-[#555] mt-1">
                {new Date(b.created_at).toLocaleString()}
              </p>
            </div>
            <div className="text-right">
              <p className="font-mono-aam text-lg text-[#1E3A8A]">
                ${b.amount.toLocaleString()}
              </p>
              {i === 0 && <p className="label-eyebrow text-[#F4C430] [text-shadow:_0_0_1px_#1E3A8A]">Highest</p>}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
